module.exports = {
          srcSet: __webpack_public_path__ + "0f912904714b0b51d8c77808fce5e0f4-20.png"+" 20w",
          images:[ {path: __webpack_public_path__ + "0f912904714b0b51d8c77808fce5e0f4-20.png",width: 20,height: 19}],
          src: __webpack_public_path__ + "0f912904714b0b51d8c77808fce5e0f4-20.png",
          toString:function(){return __webpack_public_path__ + "0f912904714b0b51d8c77808fce5e0f4-20.png"},
          
          width: 20,
          height: 19
        }